import { apiClient } from "@/lib/api/client";
import { IPaginatedRepository } from "./types";
import { Reservation, ReservationInsert, ReservationUpdate } from "@/types";

export type ReservationResponse = Reservation & {
  properties: {
    id: string;
    title: string;
    checkin_instructions: string;
    checkout_instructions: string;
  } | null;
  client: { id: string; name: string; email: string; phone: string } | null;
};

class ReservationRepository
  implements
    IPaginatedRepository<
      ReservationResponse,
      ReservationInsert,
      ReservationUpdate
    >
{
  private static instance: ReservationRepository;

  public static getInstance(): ReservationRepository {
    if (!ReservationRepository.instance) {
      ReservationRepository.instance = new ReservationRepository();
    }
    return ReservationRepository.instance;
  }

  async getAll(filters?: {
    status?: string;
    property_id?: string;
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortOrder?: string;
    page?: number;
    limit?: number;
  }): Promise<{ items: ReservationResponse[]; count: number }> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const url = queryString ? `reservations?${queryString}` : "reservations";

    return apiClient.invoke<{ items: ReservationResponse[]; count: number }>(
      url,
      {
        method: "GET",
      }
    );
  }

  async getById(id: string): Promise<ReservationResponse> {
    return apiClient.invoke<ReservationResponse>(`reservations?id=${id}`, {
      method: "GET",
    });
  }
}

export const reservationRepository = ReservationRepository.getInstance();
